import { useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { UserPlus, Search } from "lucide-react";

export function InviteCreators({ programs, members = [], onDone }) {
  const [q, setQ] = useState("");
  const [pid, setPid] = useState("");
  const [res, setRes] = useState([]);
  const program = pid || programs[0]?.id;
  const search = async (e) => {
    e.preventDefault();
    if (q.trim().length < 2) return;
    const { data } = await api.get("/creators", { params: { search: q.trim(), limit: 12 } });
    setRes(data);
  };
  const invite = async (cid) => {
    try { await api.post(`/affiliate/programs/${program}/invite`, { creator_id: cid }); toast.success("Invite sent"); setRes((r) => r.filter((c) => c.user_id !== cid)); onDone(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Couldn't invite"); }
  };
  if (!programs.length) return null;
  return (
    <div className="glass rounded-2xl p-5 space-y-3" data-testid="invite-creators-card">
      <div className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-2"><UserPlus className="h-3.5 w-3.5" /> Invite creators</div>
      <form onSubmit={search} className="flex gap-2 flex-wrap">
        {programs.length > 1 && <select value={program} onChange={(e) => setPid(e.target.value)} className="rounded-md bg-white/[0.02] border border-white/10 text-white text-sm px-3 py-2" data-testid="invite-program">{programs.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select>}
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search creators by name or niche" className="flex-1 min-w-[180px] bg-white/[0.02] border-white/10 text-white" data-testid="invite-search" />
        <Button type="submit" variant="outline" className="rounded-full border-white/15 text-white" data-testid="invite-search-btn"><Search className="h-4 w-4" /></Button>
      </form>
      <div className="space-y-1.5">
        {res.map((c) => { const existing = members.find((m) => m.program_id === program && m.creator_id === c.user_id); return (
          <div key={c.user_id} className="flex items-center justify-between gap-2 rounded-xl bg-white/[0.02] px-3 py-2 text-sm" data-testid={`invite-result-${c.user_id}`}>
            <div className="flex items-center gap-2 min-w-0">{c.avatar_url ? <img src={c.avatar_url} alt="" className="h-7 w-7 rounded-full object-cover" /> : <div className="h-7 w-7 rounded-full bg-white/10" />}<div className="min-w-0"><div className="truncate">{c.name}</div><div className="text-xs text-zinc-500 truncate">{(c.niches || []).slice(0, 2).join(" · ")}</div></div></div>
            {existing ? <span className="text-[10px] uppercase tracking-widest text-zinc-500 shrink-0" data-testid={`invite-status-${c.user_id}`}>{existing.status === "invited" ? "invite sent" : existing.status}</span> : <Button size="sm" onClick={() => invite(c.user_id)} className="rounded-full nexus-gradient text-white border-0 h-8" data-testid={`invite-btn-${c.user_id}`}>Invite</Button>}
          </div>
        ); })}
      </div>
    </div>
  );
}
